import { OrganizationInviteCoreBase } from "./organization-invite.core.base"


export class OrganizationInviteCore extends OrganizationInviteCoreBase {

}